import { InjectedFormProps, DecoratedFormProps, reduxForm, SubmissionError } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { Fragment, useState } from 'react';
import { maxLength, Validators, required } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { FieldDate } from 'src/components/redux-form/fields/FieldDate';
import { FieldDropdown } from 'src/components/redux-form/fields/FieldDropdown';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/orders-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistOrder } from 'src/store/actions/order-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { DropZoneField } from 'src/components/DropZoneField';
import Loader from '../../../../../components/Loader';
import { useSelector } from 'react-redux';
import { miniLoaderForSelector } from 'src/store/selectors/orders-selectors';
import { loaderSelector } from 'src/store/selectors/students-selectors';
import { Button, Modal } from 'react-bootstrap';
import user from '../../../../../services/user-auth';
import { changeToZeroMomentDate } from '../../../../../helpers/timeHelpers';

export interface OrderFormData {
    id: string | number;
    name: string;

    studentDropDown: SelectObject | undefined;
    orderDocName: string | null;
    orderDocMimeType: string | null;
    orderCaseTypeDropDown: SelectObject | undefined;
    orderReferralSourceDropDown: SelectObject | undefined;
    orderTypeDropDown: SelectObject | undefined;
    caseNumber: string;
    maximumAvailableHours: number;
    orderDate: string;
    caseNumberValidityFrom: string;
    orderExpiration?: string;
    caseNumberValidityTo: string;
    serviceTypeDropDown: SelectObject | undefined;
    serviceTypeProviderDropDown: SelectObject | undefined;
    statusDropDown: SelectObject | undefined;
    orderSubtypeDropDown: SelectObject | undefined;
    authorizationDateRequest: string;
    authorizationDate: string;
    referralSource: number | string;
    authorizationSourceDropDown: SelectObject | undefined;
    note: string | null;
    allocatedPeriodDropDown?: SelectObject | undefined;
    allocatedHours?: string;
    allocatedMoney?: string;
}

interface OrderFormProps {
    files: any;
    studentsValues: SelectObject[];
    valueType?: SelectObject;

    valuesOrderSubtype: SelectObject[];
    orderCaseTypeValues: SelectObject[];
    orderReferralSourceValues: SelectObject[];
    serviceTypesOrderValues: SelectObject[];
    ServiceTypeProviders: SelectObject[];
    valuesAllocatedPeriod: SelectObject[];
    valuesOrderStatus: SelectObject[];
    AuthorizationSources: SelectObject[];
    orderTypeValue: string | number;
    statusItemValue: string | number;
    status?: string | number;
    referralSource?: string | number;
    OrderTypes: SelectObject[];

    orderDoc: any;
    setOrderDoc: (it: any) => void;
    removeOrderDoc: (it: any) => void;

    setFiles: (it: []) => void;
    removeFile: (it: any) => void;
}

type InjectedProps = InjectedFormProps<OrderFormData, OrderFormProps>;

const validators: Validators<OrderFormData> = {
    name: [required({ message: 'Name is required.' }), maxLength({ max: 255 })],
    orderCaseTypeDropDown: [required({ message: 'Type is required.' }), maxLength({ max: 255 })],
    orderReferralSourceDropDown: [maxLength({ max: 255 })],
    caseNumberValidityFrom: [required({ message: 'Case Number Validity From is required.' }), maxLength({ max: 255 })],
    caseNumberValidityTo: [required({ message: 'Case Number Validity To is required.' }), maxLength({ max: 255 })],
    allocatedPeriodDropDown: [required({ message: 'Allocated Hours per is required.' }), maxLength({ max: 255 })],
    allocatedHours: [required({ message: 'Number of allocated hours is required.' }), maxLength({ max: 255 })],
    maximumAvailableHours: [required({ message: 'Maximum Available Hours is required.' }), maxLength({ max: 255 })],
    allocatedMoney: [maxLength({ max: 255 })],
    studentDropDown: [maxLength({ max: 255 })],

    caseNumber: [required({ message: 'Case Number is required.' }), maxLength({ max: 255 })],
    orderSubtypeDropDown: [maxLength({ max: 255 })],
    orderDate: [maxLength({ max: 255 })],
    authorizationDateRequest: [maxLength({ max: 255 })],
    authorizationDate: [maxLength({ max: 255 })],
    authorizationSourceDropDown: [maxLength({ max: 255 })],
    serviceTypeDropDown: [required({ message: 'Service Type is required.' }), maxLength({ max: 255 })],
    statusDropDown: [required({ message: 'Status is required.' }), maxLength({ max: 255 })],
};
const OrderForm: React.FunctionComponent<InjectedProps & OrderFormProps> = ({
    handleSubmit,
    error,
    dirty,
    files,
    setFiles,
    valueType,
    OrderTypes,
    removeFile,
    studentsValues,
    orderCaseTypeValues,
    orderReferralSourceValues,
    referralSource,
    orderDoc,
    setOrderDoc,
    serviceTypesOrderValues,
    ServiceTypeProviders,
    valuesOrderSubtype,
    valuesAllocatedPeriod,
    valuesOrderStatus,
    AuthorizationSources,
    submitting,
    status,
    statusItemValue,
    initialValues,
    orderTypeValue,
}: InjectedProps & OrderFormProps) => {
    const isNew = !initialValues || !initialValues.id;
    const statusInit = initialValues?.statusDropDown?.value ? +initialValues.statusDropDown.value : 0;
    const isDraft = statusItemValue === 3 ? true : false;
    const [dataModal, setModal] = useState(false);
    const miniLoaderFor = useSelector(miniLoaderForSelector);

    const orderDocFiles = [];
    if (orderDoc) {
        const orderDocFile = {
            attach: orderDoc,
            mimeType: initialValues.orderDocMimeType,
            name: initialValues.orderDocName,
        };

        orderDocFiles.push(orderDocFile);
    }

    const userName: string | null = user?.getUsername();
    let isAllowEditCaseValidity = false;
    if (userName) {
        isAllowEditCaseValidity = user?.emails_for_order_validity_edit.includes(userName);
    }

    const loaderForSelectorStudent = useSelector(loaderSelector);
    const handleSub = (event: any) => {
        if (statusItemValue !== status && statusItemValue === 2) {
            event.preventDefault();
            setModal(true);
        }
    };
    const fieldsRender: any = {
        1: (
            <Fragment>
                <FieldDropdown
                    name="allocatedPeriodDropDown"
                    data={valuesAllocatedPeriod}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.allocatedPeriodDropDown : undefined}
                    wrapperConfig={{
                        label: 'Allocated Hours per *:',
                    }}
                />
                <FieldInput
                    name="allocatedHours"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours: *:',
                    }}
                />
                <FieldInput
                    name="maximumAvailableHours"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.maximumAvailableHours : undefined}
                    wrapperConfig={{
                        label: 'Maximum Available Hours *',
                    }}
                />
            </Fragment>
        ),
        2: (
            <Fragment>
                <FieldInput
                    name="allocatedHours"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours *:',
                    }}
                />
            </Fragment>
        ),
        3: (
            <Fragment>
                <FieldInput
                    name="allocatedMoney"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedMoney : undefined}
                    wrapperConfig={{
                        label: 'Amount of money allocated, $ *:',
                    }}
                />
            </Fragment>
        ),
        4: <Fragment></Fragment>,
        6: (
            <Fragment>
                <FieldDropdown
                    name="allocatedPeriodDropDown"
                    data={valuesAllocatedPeriod}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.allocatedPeriodDropDown : undefined}
                    wrapperConfig={{
                        label: 'Allocated Hours per *:',
                    }}
                />
                <FieldInput
                    name="allocatedHours"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours *:',
                    }}
                />
                <FieldInput
                    name="maximumAvailableHours"
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.maximumAvailableHours : undefined}
                    wrapperConfig={{
                        label: 'Maximum Available Hours *:',
                    }}
                />
            </Fragment>
        ),
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                <FormError error={error}/>
                <FieldInput
                    name="id"
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />

                <FieldDropdown
                    name="orderTypeDropDown"
                    data={OrderTypes}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.orderTypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Order Type:',
                    }}
                />
                <FieldDropdown
                    name="orderCaseTypeDropDown"
                    data={orderCaseTypeValues}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.orderCaseTypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Type *:',
                    }}
                />

                <FieldInput
                    name="name"
                    type="text"
                    validate={!isDraft ? validators.name : undefined}
                    wrapperConfig={{
                        label: 'Name (case number/service type/service location/date range) *',
                    }}
                />
                <div className={'position-relative'}>
                    {loaderForSelectorStudent ? <Loader/> : null}
                    <FieldDropdown
                        name="studentDropDown"
                        data={studentsValues}
                        disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.studentDropDown : undefined}
                        wrapperConfig={{
                            label: 'Student Full Name:',
                        }}
                    />
                </div>
                <FieldInput
                    name="caseNumber"
                    type="text"
                    validate={
                        !isDraft
                            ? valueType && +valueType.value === +2
                                ? undefined
                                : validators.caseNumber
                            : undefined
                    }
                    wrapperConfig={{
                        label: `Case Number: ${valueType && +valueType.value === +2 ? '' : '*'}`,
                    }}
                />
                <div className="">
                    <span className={'mb-2 d-block'}>Case Number Validity</span>
                </div>
                <div className="">
                    <span className={'mb-2 d-block'}>From *</span>
                    <div className=" d-flex flex-row miniW mr-5">
                        <FieldDate
                            name="caseNumberValidityFrom"
                            type="text"
                            wrapperConfig={{
                                classes: {
                                    inputContainer: 'Date-wrap mr-5 ',
                                },
                                label: '',
                            }}
                            date={true}
                            disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                            validate={!isDraft ? validators.caseNumberValidityFrom : undefined}
                        />
                        <div className={classNames(styles.marginminus)}>
                            <span style={{ marginBottom: '5px' }} className={'d-block'}>
                                To *
                            </span>
                            <FieldDate
                                name="caseNumberValidityTo"
                                type="text"
                                date={true}
                                wrapperConfig={{
                                    classes: {
                                        inputContainer: 'Date-wrap mr-5 ',
                                    },
                                    label: '',
                                }}
                                disabled={
                                    !isNew && statusItemValue !== 3 && statusInit !== 3 && !isAllowEditCaseValidity
                                }
                                validate={!isDraft ? validators.caseNumberValidityTo : undefined}
                            />
                        </div>
                    </div>
                </div>

                <FieldDate
                    name="orderExpiration"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Order Expiration:',
                    }}
                />

                <FieldDropdown
                    name="orderSubtypeDropDown"
                    data={valuesOrderSubtype}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.orderSubtypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Order Subtype:',
                    }}
                />

                <FieldDate
                    name="orderDate"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Order Date:',
                    }}
                />

                <FieldDate
                    name="authorizationDateRequest"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Date Authorization Was Requested:',
                    }}
                />
                <FieldDate
                    name="authorizationDate"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Authorization Date:',
                    }}
                />

                <FieldDropdown
                    name="authorizationSourceDropDown"
                    data={AuthorizationSources}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.authorizationSourceDropDown : undefined}
                    wrapperConfig={{
                        label: 'Authorization Source:',
                    }}
                />

                <FieldDropdown
                    name={`serviceTypeProviderDropDown`}
                    data={ServiceTypeProviders}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.serviceTypeProviderDropDown : undefined}
                    wrapperConfig={{
                        label: 'Service Type Provider *:',
                    }}
                />

                <FieldDropdown
                    name="serviceTypeDropDown"
                    data={serviceTypesOrderValues}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.serviceTypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Service Type *:',
                    }}
                />
                {fieldsRender[orderTypeValue]}
                    <FieldDropdown
                        name="statusDropDown"
                        data={valuesOrderStatus}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.statusDropDown : undefined}
                        wrapperConfig={{
                            label: 'Order Status *:',
                        }}
                    />

                    <div style={{ display: 'none' }}>
                        <FieldDropdown
                            name="orderReferralSourceDropDown"
                            data={orderReferralSourceValues}
                            textField={'label'}
                            valueField={'value'}
                            validate={!isDraft ? validators.orderReferralSourceDropDown : undefined}
                            wrapperConfig={{
                                label: 'Referral:',
                            }}
                        />
                    </div>
                    <div className={'position-relative'}>
                        {miniLoaderFor['FILE'] ? <Loader noFull={true}/> : null}
                        <div>
                            <div>The Order:</div>
                            <DropZoneField single={true} files={orderDocFiles} setFiles={setOrderDoc}/>
                        </div>
                        <div style={{ marginBottom: '10px' }}>Other Supporting Documents:</div>
                        <DropZoneField
                            files={files}
                            setFiles={setFiles}
                            removeFile={(id: string | number) => removeFile(id)}
                        />
                    </div>

                    <div className={classNames(styles.actions)}>
                        <button
                            type="submit"
                            onClick={(event) => handleSub(event)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting}
                        >
                            <FontAwesomeIcon icon={faSave}/> {isNew ? 'Create' : 'Update'}
                        </button>
                        <Link
                            className={classNames('btn', 'btn-danger')}
                            to={Router.generate(routes.ORDERS_LIST, { status: '' })}
                        >
                            <FontAwesomeIcon icon={faBan}/> Cancel
                        </Link>
                    </div>
            </form>
            <Modal
                show={dataModal}
                onHide={() => {
                    setModal(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Cases and Sessions can't be created or updated in inactive orders. Are you sure?{' '}
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button
                            className={'mr-2'}
                            variant="secondary"
                            onClick={() => {
                                setModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                setModal(false);
                            }}
                            variant="danger"
                            type="submit"
                        >
                            Yes
                        </Button>
                    </form>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default reduxForm<OrderFormData, OrderFormProps>({
    form: 'order-form',
    enableReinitialize: true,
    onSubmit: async (data: OrderFormData, dispatch: Dispatch<any>, props: OrderFormProps) => {
        const dateFrom = new Date(data.caseNumberValidityTo).getTime();
        const dateTo = new Date(data.caseNumberValidityFrom).getTime();
        if (dateTo < dateFrom) {
            let name: any = [];

            const student_caseNumber: any = [];
            const caseDate: any = [];
            if (data.studentDropDown) {
                student_caseNumber.push(data.studentDropDown.label);
            }
            if (data.caseNumber) {
                student_caseNumber.push(data.caseNumber);
            }
            if (student_caseNumber.length) {
                name.push(student_caseNumber.join('_'));
            }

            if (data.serviceTypeProviderDropDown?.value) {
                name.push(data.serviceTypeProviderDropDown.label);
            }
            if (data.serviceTypeDropDown?.value) {
                name.push(data.serviceTypeDropDown.label);
            }
            if (data.caseNumberValidityFrom) {
                caseDate.push(changeToZeroMomentDate(data.caseNumberValidityFrom));
            }

            if (data.caseNumberValidityTo) {
                caseDate.push(changeToZeroMomentDate(data.caseNumberValidityTo));
            }
            if (caseDate.length) {
                name.push(caseDate.join('_'));
            }

            //if (data.location) {
            //    name.push(data.location);
            //}

            name = name.join('/');
            data.name = name;

            await asyncPersistOrder(data, { orderDoc: props.orderDoc, files: props.files }, dispatch);
        } else {
            //toast.error('Incorrect date!');
            throw new SubmissionError({
                caseNumberValidityTo: 'Incorrect date!',
                caseNumberValidityFrom: 'Incorrect date!',
                _error: 'Incorrect date!',
            });
        }
    },
    onSubmitSuccess(result: any, dispatch: Dispatch<any>, props: DecoratedFormProps<OrderFormData, OrderFormProps>) {},

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(OrderForm);
